import React, { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import {
  Checkbox,
  Tabs,
  Tab,
  Box,
  Button,
  Grid,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  FormControlLabel
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { getVal, setBool, getTableData, getPriceChangeData } from "../../helpers/process_morningstar.js";
import { DownloadInvoiceButton } from '../Pdf.js';
import { fetchDividendData } from "../../helpers/graph_middleware.js";


function formatMarketCap(value) {
  if (value >= 1_000_000) {
    return `$${(value / 1_000_000).toFixed(2)} Trillion`;
  } else if (value >= 1_000) {
    return `$${(value / 1_000).toFixed(2)} Billion`;
  } else if (value >= 100) {
    return `$${(value).toFixed(2)} Million`;
  } else {
    return `$${value.toFixed(2)}`;
  }
}


function Header({graphData, pdfImage, pdfDescription}) {
    const { ticker } = useParams();
    const [companyDetail, setCompanyDetail] = useState([])
    const [closePrice, setClosePrice] = useState([])
    const [security, setSecurity] = useState([])
    const [parameters, setParameters] = useState([])
    const [generalProfile, setGeneralProfile] = useState([])
    const [currency, setCurrency] = useState()

    const [capRD] = useState(getVal("capRD"));
    const [includeOtherIncome] = useState(getVal("includeOtherIncome"));
    const [selectedTax] = useState(getVal("selectedTax"));

    const [dividendYield, setDividendYield] = useState()
    const [dividendPayout, setDividendPayout] = useState()
    const [dividendGrowth, setDividendGrowth] = useState()

    const [priceChg52WeekHigh, setPriceChg52WeekHigh] = useState()
    const [priceChg52WeekLow, setPriceChg52WeekLow] = useState()
    const [priceChg1Year, setPriceChg1Year] = useState()

    useEffect(() => {
        const fetchData = async () => {
            const companyTable = await getTableData("Company")
            setCompanyDetail(companyTable[0])

            const stockTable = await getTableData("PVTwoYears")
            // console.log("Stock Table:", stockTable)
            setClosePrice(stockTable[3])

            const priceChangeData = await getPriceChangeData();
            console.log('priceChangeData:', priceChangeData);
            setPriceChg52WeekHigh(priceChangeData.priceChg52WeekHigh);
            setPriceChg52WeekLow(priceChangeData.priceChg52WeekLow);
            setPriceChg1Year(priceChangeData.priceChg1Year);

            const securityTable = await getTableData("Security")
            setSecurity(securityTable[0])

            const parametersTable = await getTableData("Parameters")
            setParameters(parametersTable)
            setCurrency(parametersTable[7][ticker.toUpperCase()])

            const generalProfileTable = await getTableData("General Profile")
            setGeneralProfile(generalProfileTable[0])

            const dividendData = await fetchDividendData(capRD, includeOtherIncome, selectedTax)
            // console.log("Dividend Data:", dividendData)
            const dividendYieldValue = dividendData.at(-1)?.dividendYield || 0;
            setDividendYield(dividendYieldValue);

            const dividendPayoutValue = dividendData.at(-1)?.payoutRatio || 0;
            setDividendPayout(dividendPayoutValue);

            const dividendGrowthValue = dividendData.at(-1)?.dividendGrowth || 0;
            setDividendGrowth(dividendGrowthValue);
        }


    fetchData()
    }, [])

    const companyName = companyDetail['StandardName']


    const dateKeys = Object.keys(closePrice).filter(key => /^\d{4}-\d{2}-\d{2}$/.test(key));
    dateKeys.sort((a, b) => new Date(a) - new Date(b));

    const latestDate = dateKeys[dateKeys.length - 1];
    const secondDate = dateKeys[dateKeys.length - 2];
    const latestPrice = Math.round(closePrice[latestDate] * 100) / 100;
    const secondPrice = Math.round(closePrice[secondDate] * 100) / 100

    const priceChange = Math.round((latestPrice - secondPrice) * 100) / 100
    const percentChange = Math.round((priceChange / secondPrice) * 100 * 100) / 100

    const marketCap = graphData[graphData.length - 1]['marketCap']

    const sectorName = companyDetail['SectorName']

    const primaryExchange = security['ExchangeId']

    const companyWebsite = generalProfile['HeadquarterHomepage']
    const companyLocation = generalProfile['HeadquarterCity'] + ', ' + generalProfile['HeadquarterProvince'] + ', ' + generalProfile['HeadquarterCountry']

    const headerData = {
      companyName,
      ticker,
      latestPrice,
      priceChange,
      percentChange,
      latestDate,
      marketCap,
      sectorName,
      currency,
      primaryExchange,
      companyWebsite,
      companyLocation,
      pdfImage,
      pdfDescription
    };

  return (
    <Grid 
    container 
    spacing={1} 
    alignItems="flex-start" 
    sx={{ mb: 1 }}
  >

    <Grid item xs={12} sm={6} md={5}>
      <Box>
        <Typography
          variant="h6"
          sx={{
            m: 0,
            fontWeight: "bold",
            color: "#002060"
          }}
        >
          {companyName} ({ticker.toUpperCase()})
        </Typography>

      </Box>
    </Grid>

    <Grid 
      item 
      xs={12} 
      sm={6} 
      md={3}
      sx={{
        textAlign: { xs: "left", md: "left" },
        pl: { xs: 0, sm: 2, md: 6 }
      }}
    >
      <Link
        to={companyWebsite}
        target="_blank" rel="noopener noreferrer"
      >
        {companyWebsite}
      </Link>

      <Typography variant="subtitle2" sx={{ color: "black" }}>
        {companyLocation}
      </Typography>
    </Grid>

    <Grid 
      item 
      xs={12} 
      sm={6} 
      md={2}
      sx={{
        pl: { xs: 0, sm: 2, md: 6 },
      }}
    >
      {/* <Typography variant="subtitle2" sx={{ color: "black" }}>
        Column 3 Placeholder
      </Typography> */}
    </Grid>

    <Grid 
      item 
      xs={12} 
      sm={6} 
      md={2}
      sx={{
        display: "flex",
        justifyContent: { xs: "flex-start", md: "flex-end" },
        // pl: { xs: 0, sm: 2, md: 6 },
      }}
    >
      {pdfImage && (
        <DownloadInvoiceButton
          chartImage={pdfImage}
          description={pdfDescription}
          headerData={headerData}
        />
      )}

    </Grid>







    {/* LEFT COLUMN */}
    <Grid item xs={12} sm={6} md={5}>
      <Box>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", color: "#002060" }}
        >
          ${latestPrice.toLocaleString()}{" "}
          <Box component="span" sx={{ fontSize: "0.75rem", color: "black" }}>
            <Box
              component="span"
              sx={{
                fontSize: "0.75rem",
                fontWeight: "bold",
                color: percentChange >= 0 ? "green" : "red",
              }}
            >
              {percentChange >= 0 ? `+${priceChange}` : priceChange} (
              {percentChange >= 0 ? `+${percentChange}%` : `${percentChange}%`})
            </Box>
            {" "}as of {latestDate}
          </Box>
        </Typography>

        <Typography variant="subtitle2" sx={{ color: "black" }}>
          Market Cap: {formatMarketCap(marketCap)}
        </Typography>

        <Typography variant="subtitle2" sx={{ color: "black" }}>
          Sector: {sectorName}
        </Typography>
      </Box>
    </Grid>

    {/* MIDDLE COLUMN */}
    <Grid 
      item 
      xs={12} 
      sm={6} 
      md={4}
      sx={{
        textAlign: { xs: "left", md: "left" },
        pl: { xs: 0, sm: 2, md: 6 },
        // backgroundColor: "#f0f0f0", borderRadius: 1, p: 0
      }}
    >
      <Typography variant="subtitle2" sx={{ color: "black" }}>
        Financials Reported In: {currency}
      </Typography>
      <Typography variant="subtitle2" sx={{ color: "black" }}>
        Stock Chart In: {currency}
      </Typography>
      <Typography variant="subtitle2" sx={{ color: "black" }}>
        Primary Exchange: {primaryExchange}
      </Typography>
    </Grid>

    {/* COLUMN 3 */}
    <Grid 
      item 
      xs={12} 
      sm={6} 
      md={3}
      sx={{ backgroundColor: "#f0f0f0", borderRadius: 1, pb: 1, pt: 0, pl: 2, pr: 1 }}
    >
      <Grid container columnSpacing={2} >
        <Grid item xs={6}>
          <Typography variant="subtitle2" >
            Dividends
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle2" >
            Price Change
          </Typography>
        </Grid>

        <Grid item xs={6} >
            <Box sx={{ display: "flex" }}>
              <Typography variant="subtitle2" sx={{ flexGrow: 1, fontSize: "0.6rem" }}>
                Yield:
              </Typography>

              <Typography variant="subtitle2" sx={{ fontSize: "0.6rem" }}>
                {dividendYield?.toFixed(2)}%
              </Typography>
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Box sx={{ display: "flex" }}>
            <Typography variant="subtitle2" sx={{ flexGrow: 1, fontSize: "0.6rem" }}>
              52 Week High:
            </Typography>

            <Typography variant="subtitle2" sx={{ fontSize: "0.6rem", color: priceChg52WeekHigh >= 0 ? "green" : "red" }}>
              {priceChg52WeekHigh >= 0 ? `+${priceChg52WeekHigh}%` : `(${priceChg52WeekHigh}%)`}
            </Typography>
          </Box>
        </Grid>
        
        <Grid item xs={6}>
          <Box sx={{ display: "flex" }}>
            <Typography variant="subtitle2" sx={{ flexGrow: 1, fontSize: "0.6rem" }}>
              Payout:
            </Typography>

            <Typography variant="subtitle2" sx={{ fontSize: "0.6rem" }}>
              {dividendPayout?.toFixed(2)}%
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ display: "flex" }}>
            <Typography variant="subtitle2" sx={{ flexGrow: 1, fontSize: "0.6rem" }}>
              52 Week Low:
            </Typography>

            <Typography variant="subtitle2" sx={{ fontSize: "0.6rem", color: priceChg52WeekLow >= 0 ? "green" : "red" }}>
              {priceChg52WeekLow >= 0 ? `${priceChg52WeekLow}%` : `(${priceChg52WeekLow}%)`}
            </Typography>
          </Box>
        </Grid>
        
        <Grid item xs={6}>
          <Box sx={{ display: "flex" }}>
            <Typography variant="subtitle2" sx={{ flexGrow: 1, fontSize: "0.6rem" }}>
              Growth:
            </Typography>

            <Typography variant="subtitle2" sx={{ fontSize: "0.6rem" }}>
              {dividendGrowth?.toFixed(2)}%
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Box sx={{ display: "flex" }}>
            <Typography variant="subtitle2" sx={{ flexGrow: 1, fontSize: "0.6rem" }}>
              1 Year:
            </Typography>

            <Typography variant="subtitle2" sx={{ fontSize: "0.6rem", color: priceChg1Year >= 0 ? "green" : "red" }}>
              {priceChg1Year >= 0 ? `${priceChg1Year}%` : `(${priceChg1Year}%)`}
            </Typography>
          </Box>
        </Grid>
      </Grid>

    </Grid>

    
  </Grid>

  );
}

export default Header;
